import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import agentRequestStartAction from './agentRequestStart.action.json'

const agentRequestStartDefinition = defineAction({
  ...agentRequestStartAction,
  userActivityLogInput: 'omit' as const,
  input: object({
    entrepreneurCpf: string(),
    agentCpf: string(),
    confirmationCode: string(),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      inAttendance: 'in_attendance',
    }),
    startedAt: dateTime(),
  }),
})

export default agentRequestStartDefinition
